/* Griptec sticky ATC popup.
   Reveals a floating buy card when the buy-box column scrolls above the
   viewport, mirrors the selected tier, and forwards its Add click to the
   real product form. IntersectionObserver-driven; reduced-motion safe. */
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.griptecStickyInit === 'true') return;
    bar.dataset.griptecStickyInit = 'true';

    var sectionId = bar.getAttribute('data-section-id');
    var target = document.getElementById('ProductInfo-' + sectionId) ||
      document.getElementById('MainProduct-' + sectionId);
    var form = document.getElementById('product-form-' + sectionId);
    var priceEl = bar.querySelector('.g-sticky-atc__price');
    var tierEl = bar.querySelector('.g-sticky-atc__tier');
    var btn = bar.querySelector('.g-sticky-atc__btn');

    if (!target) return;

    var observer = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', !e.isIntersecting && below);
    }, { threshold: 0 });
    observer.observe(target);

    // Mirror tier selection into the popup.
    document.addEventListener('griptec:tier-change', function (ev) {
      var d = ev.detail || {};
      if (d.sectionId && d.sectionId !== sectionId) return;
      if (priceEl && d.price) priceEl.textContent = d.price;
      if (tierEl) {
        var label = d.name || '';
        if (d.save) label += ' · ' + d.save.toLowerCase();
        tierEl.textContent = label;
      }
    });

    // Forward the popup's Add to the real form's submit button.
    if (btn && form) {
      btn.addEventListener('click', function () {
        var realBtn = form.querySelector('[name="add"]');
        if (realBtn) {
          realBtn.click();
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-griptec-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
